/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
import { webApi } from "../../lib/WebApi"
import { multisportify } from "trux"

let defaultValue = {
    loading: false,
    complete: false,
    error: null,
    value: null,
}

const loadGames = (teamName) => {
    return (dispatch, getState) => {
        let team = getState().team.value
        let gamesState = getState().games
        let staleness =
            Date.now() - (gamesState.last_updated ? gamesState.last_updated : 0)

        if (gamesState.loading) {
            // console.log("Loader.loadGames skip games update already loading")
            return { type: "NOOP" }
        } else if (!team) {
            // console.log("Loader.loadGames skip games update team not loading")
            return { type: "NOOP" }
        } else if (team && team.name !== teamName) {
            // console.log("Loader.loadGames resetting games teamName mismatch")
            if (gamesState.value !== null) {
                dispatch({
                    type: "COMMON_SET",
                    key: "games",
                    value: {
                        loading: false,
                        complete: false,
                        error: null,
                        value: null,
                    },
                    defaultValue: { ...defaultValue },
                })
            }
            return
        } else if (team && gamesState.complete && staleness < 60 * 10 * 1000) {
            //console.log("Loader.loadGames skip games update already complete", staleness)
            return { type: "NOOP" }
        }

        // console.log("loadGames time diff", staleness)
        // console.log("Loader.loadGames loading games for", teamName)

        dispatch({
            type: "COMMON_SET",
            key: "games",
            value: {
                loading: true,
                complete: false,
                error: null,
                last_updated: 0,
            },
            defaultValue: { ...defaultValue },
        })

        return webApi
            .getGames(team.team_id)
            .then((games) => {
                games = multisportify(games)
                for (let i in games) {
                    let game = games[i]
                    let gid = `${game.home_team.name}-${game.game_id}`
                    // remove this when we have real sport type data from the server
                    // if (game.video_render_type) {
                    //     game.sport_type = game.video_render_type.startsWith(
                    //         "baseball"
                    //     )
                    //         ? "baseball"
                    //         : "soccer"
                    // }
                    game["game_id_hash"] = gid
                    if (game.approx_start_time) {
                        game.date = `${game.date} ${game.approx_start_time}`
                    }
                    game.video_sport_type = game.sport_type
                    if(game.sport_type === "soccer" && game.video_render_type.includes("baseball")) {
                        game.sport_type = "baseball"
                    }
                }
                return games
            })
            .then((games) => {
                // calculate processing status of games

                for (let i in games) {
                    let game = games[i]

                    let now = 4
                    let start = 1
                    let end = 3
                    let diff = null

                    let dateParts = game.date.split(" ")
                    let dayParts = dateParts[0].split("-")
                    let timParts = ["08", "30"]
                    if (dateParts.length > 1) {
                        timParts = dateParts[1].split(":")
                    }

                    let y = parseInt(dayParts[0], 10)
                    let m = parseInt(dayParts[1], 10) - 1
                    let d = parseInt(dayParts[2], 10)
                    let hh = parseInt(timParts[0], 10)
                    let mm = parseInt(timParts[1], 10)

                    now = new Date().getTime()
                    start = new Date(Date.UTC(y, m, d, hh, mm)).getTime()
                    end = new Date(Date.UTC(y, m, d, hh + 3, mm)).getTime()
                    diff = now - start

                    if (now < start) {
                        //console.log("scheduled game", now, start, game.date)
                        game.list_status = "scheduled"
                    } else if (start < now && now < end) {
                        game.list_status = "editing"
                    } else if (
                        game.camera_type === "trace" &&
                        (parseInt(game.sensor_data_uploaded, 10) < 1 ||
                            parseInt(game.video_files_uploaded, 10) < 1)
                    ) {
                        game.list_status = "waiting"
                    } else if (
                        game.camera_type === "regular" &&
                        game.status === "unprocessed"
                    ) {
                        game.list_status = "waiting"
                    } else if (
                        diff &&
                        diff < 2.88e7 &&
                        game.webapp_ready === 0 &&
                        game.status !== "process_error"
                    ) {
                        game.list_status = "processing"
                    } else if (
                        (diff || diff >= 2.88e7) &&
                        game.webapp_ready === 0 &&
                        game.status !== "process_error"
                    ) {
                        game.list_status = "error"
                    } else if (game.status !== "processed") {
                        game.list_status = "error"
                    } else {
                        game.list_status = "ready"
                    }

                    //// second pass

                    // if status is processing we are processing
                    if (game.status === "processing") {
                        game.list_status = "processing"
                    }

                    // game.video_files_uploaded is unreliable second pass to fix
                    if (
                        game.status === "processed" &&
                        game.webapp_ready === "1"
                    ) {
                        game.list_status = "ready"
                    }

                    // hide old games in waiting or error state
                    // console.log(game.game_id, game.list_status, diff, 9 * 24 * 60 * 60 * 1000)
                    if (
                        game.list_status === "waiting" &&
                        diff > 9 * 24 * 60 * 60 * 1000
                    ) {
                        game.list_status = "hide"
                    }
                    if (
                        game.list_status === "error" &&
                        diff > 9 * 24 * 60 * 60 * 1000
                    ) {
                        game.list_status = "hide"
                    }

                    // if still in qa game is not ready
                    if (
                        game.list_status === "ready" &&
                        game.subtasks_statuses &&
                        game.subtasks_statuses.emails
                    ) {
                        if (
                            game.subtasks_statuses.emails.status !== "processed"
                        ) {
                            game.list_status = "processing"
                        }
                    }

                    //hide games that has quarantine
                    if (
                        game.quarantine_status &&
                        game.quarantine_status !== "none"
                    ) {
                        game.list_status = "hide"
                    }

                    if (game.list_status === "hide") {
                        // console.log("hiding", game.game_id)
                    }

                    // Show flagged for support games as processing
                    if (game.list_status === "error") {
                        game.list_status = "processing"
                    }

                    // if emails sent list as ready
                    if (
                        game.subtasks_statuses &&
                        game.subtasks_statuses.emails &&
                        game.subtasks_statuses.emails.status === "processed"
                    ) {
                        game.list_status = "ready"
                    }

                    // Exclude games in quarantine
                    if (
                        game.quarantine_status &&
                        game.quarantine_status.length > 0 &&
                        game.quarantine_status !== "none"
                    ) {
                        game.list_status = "hide"
                    }
                }

                return games
            })
            .then((games) => {
                return games.sort((a, b) => {
                    return a.date.localeCompare(b.date) * -1
                })
            })
            .then((games) => {
                dispatch({
                    type: "COMMON_SET",
                    key: "games",
                    value: {
                        loading: false,
                        complete: true,
                        error: null,
                        value: games,
                        last_updated: Date.now(),
                    },
                    defaultValue: { ...defaultValue },
                })
                // console.log("Loader.loadGames complete", games)
            })
            .catch((err) => {
                dispatch({
                    type: "COMMON_SET",
                    key: "games",
                    value: {
                        loading: false,
                        complete: true,
                        error: err,
                        value: null,
                        last_updated: 0,
                    },
                    defaultValue: { ...defaultValue },
                })
                // console.log("Loader.loadGames ERROR", err)
            })
    }
}

export default loadGames
